import getDoaminName from 'lib/getDomainName';
import { nascsubdomain, trainingsubdomain } from 'redux/reducers/settings';
import * as Yup from 'yup';
export interface IInitialValue {
  old_password: string;
  new_password: string;
  confirm_password: string;
}
export const initialValue: IInitialValue = {
  old_password: '',
  new_password: '',
  confirm_password: ''
};

export const SignUpValidationSchema = {
  old_password: Yup.string()
    .min(6, 'Old Password is greater than 6 characters')
    .max(50, 'Too Long!')
    .required('Old Password is required'),
  new_password: Yup.string()
    .min(6, 'New Password must be greater than 6 characters!')
    .max(50, 'Too Long!')
    .required('New password is required'),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('new_password'), null], "Password doesn't Match")
    .required('Confirm Password is required')
};

export interface IPersonalDetails {
  first_name: string;
  middle_name: string;
  last_name: string;
  first_name_np: string;
  middle_name_np: string;
  last_name_np: string;
  gender: string;
  dob: string;
  marital_status: string;
  caste: string;
  religion: string;
  ethnicity: string;
  citizen_ship_no: string;
  citizen_ship_issued_place: string;
  citizen_ship_issued_date: string;
  citizen_ship_issued_date_bs: string;
  image: File | null;
  dob_BS: string;
  bank_name: string;
  bank_account_holder: string;
  bank_account_number: string;
  bank_branch: string;
  pan_number: number
  recommendation_letter: string
  employee_id: string
  dob_bs: string
  employee_sn: string

}
export const PersonalDetailsInitialValues: IPersonalDetails = {
  first_name: '',
  middle_name: '',
  last_name: '',
  first_name_np: '',
  middle_name_np: '',
  last_name_np: '',
  gender: '',
  dob: '',
  marital_status: '',
  caste: '',
  religion: '',
  ethnicity: '',
  citizen_ship_no: '',
  citizen_ship_issued_place: '',
  citizen_ship_issued_date: '',
  image: null as File | null,
  dob_BS: '',
  bank_name: '',
  bank_account_holder: '',
  bank_account_number: '',
  bank_branch: '',
  // bank_address: '',
  citizen_ship_issued_date_bs: '',
  pan_number: 0,
  recommendation_letter: "",
  employee_id: '',
  dob_bs: '',
  employee_sn: ''

};
const domain = getDoaminName();

/** Bank details are only mandatory on the TMS (nasc) domain. */
// export const isBankDetailRequired = domain === trainingsubdomain;
export const isBankDetailRequired = domain === trainingsubdomain;

const requiredWhenTms = (message: string) =>
  isBankDetailRequired ? Yup.string().required(message) : Yup.string().nullable();

export const PersonalDetailsValidationSchema = Yup.object().shape({
  first_name: Yup.string().required('First name is required'),
  middle_name: Yup.string().nullable(),
  last_name: Yup.string().required('Last name is required'),
  first_name_np: Yup.string().optional(),
  middle_name_np: Yup.string().nullable(),
  gender: Yup.string().required('Gender is required'),
  dob: Yup.string().required('Date of birth is required'),
  marital_status: Yup.string().required('Marital status is required'),
  caste: Yup.string().nullable(),
  religion: Yup.string().nullable(),
  ethnicity: Yup.string().nullable(),
  citizen_ship_no: Yup.string().optional(),
  citizen_ship_issued_place: Yup.string().optional(),
  citizen_ship_issued_date: Yup.string().optional().nullable(),
  citizen_ship_issued_date_bs: Yup.string().optional().nullable(),
  bank_name: requiredWhenTms('Bank Name is required'),
  bank_account_holder: requiredWhenTms('Account Holder Name is required'),
  bank_account_number: requiredWhenTms('Account Number is required'),
  bank_branch: requiredWhenTms('Branch is required'),
  pan_number: isBankDetailRequired
    ? Yup.number()
      .typeError('PAN Number is required')
      .moreThan(0, 'PAN Number is required')
      .required('PAN Number is required')
    : Yup.number().nullable(),
  recommendation_letter: Yup.string().nullable(),
  employee_id: Yup.string().nullable(),
  employee_sn: Yup.string().nullable(),

  dob_bs: Yup.string().nullable()

});

export const genderOptions: {
  label: string;
  value: string;
}[] = [
    {
      label: 'Male',
      value: '1'
    },
    {
      label: 'Female',
      value: '2'
    },
    {
      label: 'Others',
      value: '3'
    }
  ];

export const MaritalStatusOptions: {
  label: string;
  value: string;
}[] = [
    {
      label: 'Single',
      value: '1'
    },
    {
      label: 'Married',
      value: '2'
    }
  ];

export const CastOptions: {
  label: string;
  value: string;
}[] = [
    {
      label: 'Bramhin',
      value: '1'
    },
    {
      label: 'Bramhin Terai',
      value: '2'
    },
    {
      label: 'Sunuwar',
      value: '3'
    },
    {
      label: 'Bishwokarma',
      value: '4'
    },
    {
      label: 'Musalman',
      value: '5'
    },
    {
      label: 'Sanyashi',
      value: '6'
    },
    {
      label: 'Gurung',
      value: '7'
    },
    {
      label: 'Rai',
      value: '8'
    },
    {
      label: 'Limbu',
      value: '9'
    },
    {
      label: 'Magar',
      value: '10'
    },
    {
      label: 'Mijar',
      value: '11'
    },
    {
      label: 'Teli',
      value: '12'
    },
    {
      label: 'Rajput',
      value: '13'
    },
    {
      label: 'Yadav',
      value: '14'
    },
    {
      label: 'Others',
      value: '15'
    }
  ];

export const ReligionOptions: {
  label: string;
  value: string;
}[] = [
    {
      label: 'Hindu',
      value: '1'
    },
    {
      label: 'Buddhism',
      value: '2'
    },
    {
      label: 'Islam',
      value: '3'
    },
    {
      label: 'Kiratism',
      value: '4'
    },
    {
      label: 'Christian',
      value: '5'
    },
    {
      label: 'Jainism',
      value: '6'
    },
    {
      label: 'Bahai',
      value: '7'
    },
    {
      label: 'Sikhim',
      value: '8'
    },
    {
      label: 'Others',
      value: '9'
    }
  ];
